var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Grid',{attrs:{"gtc":"1fr 1fr","gap":"20px","align-items":"start"}},[_c('Email',{attrs:{"emails":_vm.emails}}),_c('History',{attrs:{"activities":_vm.activities}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }